/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Box, Button, CardMedia, Slide, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { yellow, grey } from "@mui/material/colors";
import React, { useState, useEffect } from "react";
import { MOBLIE_VIEW_WIDTH } from "../../constants/constants";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const sideParent = (matches, upper, lower) => css`
  background-color: #000000;
  background-image: url(${lower}), url(${upper});
  background-repeat: no-repeat;
  background-size: ${matches ? "100% 189%, 60% 70%" : "180% 180%, 240% 65%"};
  background-position-x: center;
  display: flex;
  flex-direction: column;
  height: ${matches ? "90vh" : "65vh"};
  postion: relative;
`;

const sideImage = (matches) => css`
  height: ${matches ? "70%" : "65%"};
  object-fit: scale-down;
`;

const buttonstyle = css`
  &:hover {
    cursor: pointer;
  }
  text-align: center;
  color: white;
  margin: auto;
  font-size: 14px;
  border: 2px solid white;
  border-radius: 25px;
  width: 25%;
  min-width: 200px;
  font-family: "Arial", sans-serif;
`;

const highlightButton = css`
  width: 50px;
  height: 2px;
  z-index: 4;
  border: 0;
  background-color: ${grey[800]};
  transition: background-color 0.5s !important;
`;

const highlightButtonHover = css`
  width: 50px;
  height: 2px;
  z-index: 4;
  border: 0;
  background-color: ${grey[50]};
  transition: font-size 1s !important;
`;

const hoverDivMob = css`
  margin: auto;
  text-align: center;
  max-width: 80%;
  margin-bottom: 20px;
`;

const useStyles = makeStyles({
  displayButtonHover: {
    zIndex: 4,
    height: "60% !important",
    fontSize: "1.5rem !important",
    color: `${yellow[50]} !important`,
    paddingLeft: "25px !important",
    borderLeft: `1px solid ${grey[500]} !important`,
    borderRadius: "0  !important",
    transition: "font-size 1s !important",
    fontFamily: "MB Corpo A Title Condensed !important",
  },
  displayButton: {
    zIndex: 4,
    height: "60% !important",
    fontSize: "1rem !important",
    color: `${grey[700]} !important`,
    paddingLeft: "25px !important",
    borderLeft: `1px solid ${grey[800]} !important`,
    borderRadius: "0  !important",
    transition: "font-size 1s !important",
    fontFamily: "MB Corpo A Title Condensed !important",
  },
  slide: {
    width: "100%",
    height: "100%",
    position: "absolute",
    transition: "0.9s",
    overflowX: "hidden",
  },
  buttons: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "6rem",
    marginTop: "6rem",
    alignItems: "baseline",
  },
  mobileButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
    margin: "10px",
  },
  mobileButtonInner: {
    border: "0 !important",
  },
});

export default function SidebarCarousel({ sideCarouselData }) {
  const [selected, setSelected] = useState("");
  const [backgroundImage, setBackgroundImage] = useState("");
  const [images, setImages] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [link, setLink] = useState({
    buttonLink: [],
    buttonText: [],
    isExternalLink: [],
  });
  const [upperBackground, setUpperBackground] = useState([]);
  const [lowerBackground, setLowerBackground] = useState([]);
  const [upperImage, setUpperImage] = useState("");
  const [lowerImage, setLowerImage] = useState("");
  const containerRef = React.useRef(null);
  const matches = useMediaQuery(MOBLIE_VIEW_WIDTH);
  const styles = useStyles();

  useEffect(() => {
    const image = [];
    const button = [];
    const buttonText = [];
    const buttonLink = [];
    const isExternalLinks = [];
    const upper = [];
    const lower = [];
    sideCarouselData?.map((item) => {
      if (item?.isExternalLink) {
        image.push(item?.isExternalLink);
      } else {
        image.push(
          process.env.REACT_APP_BASEURL + item?.media?.data?.attributes?.url
        );
      }
      button.push(item?.title);
      buttonText.push(item?.buttonText);
      buttonLink.push(item?.buttonLink);
      isExternalLinks.push(item?.isExternalLink);
      upper.push(
        process.env.REACT_APP_BASEURL +
          item?.upperBackgroundImage?.data?.attributes?.url
      );
      lower.push(
        process.env.REACT_APP_BASEURL +
          item?.lowerBackgroundImage?.data?.attributes?.url
      );
    });
    setImages([...image]);
    setButtons([...button]);
    setLink((prevState) => ({
      ...prevState,
      buttonText: buttonText,
      buttonLink: buttonLink,
      isExternalLinks: isExternalLinks,
    }));
    setUpperBackground([...upper]);
    setLowerBackground([...lower]);
  }, [sideCarouselData]);

  useEffect(() => {
    setSelected(buttons[0]);
    setBackgroundImage(images[0]);
    setUpperImage(upperBackground[0]);
    setLowerImage(lowerBackground[0]);
  }, [images, buttons]);

  const handleHover = (index, method = "") => {
    if (matches) {
      setBackgroundImage(images[index]);
      setSelected(buttons[index]);
      setUpperImage(upperBackground[index]);
      setLowerImage(lowerBackground[index]);
    } else {
      if (method === "sub") {
        if (!index) {
          setBackgroundImage(images[buttons.length - 1]);
          setSelected(buttons[buttons.length - 1]);
          setUpperImage(upperBackground[upperBackground.length - 1]);
          setLowerImage(lowerBackground[lowerBackground.length - 1]);
        } else {
          setBackgroundImage(images[index - 1]);
          setSelected(buttons[index - 1]);
          setUpperImage(upperBackground[index - 1]);
          setLowerImage(lowerBackground[index - 1]);
        }
      } else if (method === "add") {
        if (index === buttons.length - 1) {
          setBackgroundImage(images[0]);
          setSelected(buttons[0]);
          setUpperImage(upperBackground[0]);
          setLowerImage(lowerBackground[0]);
        } else {
          setBackgroundImage(images[index + 1]);
          setSelected(buttons[index + 1]);
          setUpperImage(upperBackground[index + 1]);
          setLowerImage(lowerBackground[index + 1]);
        }
      }
    }
  };

  const sliderArray = images.map((item) => (
    <CardMedia
      component="img"
      key={item.toString()}
      css={() => sideImage(matches)}
      image={item}
      alt="No Image Present"
    ></CardMedia>
  ));

  const handleClick = (term) => {
    const index = buttons.indexOf(term);
    if (link.isExternalLinks[index]) {
      window.open(link.buttonLink[index]);
    } else {
      window.location = link.buttonLink[index];
    }
  };

  return (
    <Box ref={containerRef}>
      <div css={() => sideParent(matches, upperImage, lowerImage)}>
        <div className={matches ? styles.buttons : styles.mobileButtons}>
          {buttons.map((item, index) => (
            <Button
              className={`${
                selected === item
                  ? styles.displayButtonHover
                  : styles.displayButton
              } ${!matches ? styles.mobileButtonInner : ""}`}
              key={index}
              onMouseEnter={() => matches && handleHover(index)}
              onClick={() => !matches && handleClick(item)}
              variant="text"
            >
              {item}
            </Button>
          ))}
        </div>
        {images?.map((item, index) => (
          <Slide
            timeout={{ enter: 1500, exit: 1500 }}
            appear={false}
            easing={{
              enter: "cubic-bezier(0.33, 1, 0.68, 1)",
              exit: "cubic-bezier(0.33, 1, 0.68, 1)",
            }}
            className={styles.slide}
            key={index}
            direction="right"
            in={Boolean(item === backgroundImage)}
            container={containerRef.current}
          >
            {sliderArray[index]}
          </Slide>
        ))}
        <Box
          style={{
            margin: "auto",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {!matches && sideCarouselData?.length > 1 && (
            <Button
              onClick={() => handleHover(buttons.indexOf(selected), "sub")}
              style={{
                background: "transparent",
                boxShadow: "none",
                zIndex: 1,
              }}
            >
              <ArrowBackIosIcon
                style={{ fontSize: "30px" }}
                sx={{ color: yellow[50] }}
              ></ArrowBackIosIcon>
            </Button>
          )}
          {!matches && sideCarouselData?.length > 1 && (
            <Button
              onClick={() => handleHover(buttons.indexOf(selected), "add")}
              style={{
                background: "transparent",
                boxShadow: "none",
                zIndex: 1,
              }}
            >
              <ArrowForwardIosIcon
                style={{ fontSize: "30px" }}
                sx={{ color: yellow[50] }}
              ></ArrowForwardIosIcon>
            </Button>
          )}
        </Box>
      </div>
      <Box
        style={{
          transform: matches ? "translate(0, -450%)" : "translate(0, -150%)",
        }}
      >
        {!matches && (
          <div css={() => hoverDivMob}>
            {buttons.map((item, index) => (
              <button
                key={index}
                css={() =>
                  selected === item ? highlightButtonHover : highlightButton
                }
              ></button>
            ))}
          </div>
        )}
        {link?.buttonText[buttons?.indexOf(selected)] && (
          <Box css={() => buttonstyle} onClick={() => handleClick(selected)}>
            {link?.buttonText[buttons?.indexOf(selected)]}
          </Box>
        )}
      </Box>
    </Box>
  );
}
